import AmazonIcon from "@redotech/redo-icons/carriers/amazon.svg";
import AustraliaPostIcon from "@redotech/redo-icons/carriers/australia-post.svg";
import AustrianPostIcon from "@redotech/redo-icons/carriers/austrian-post.svg";
import BpostIcon from "@redotech/redo-icons/carriers/bpost.svg";
import CanadaPostIcon from "@redotech/redo-icons/carriers/canada-post.svg";
import ChronopostIcon from "@redotech/redo-icons/carriers/chronopost.svg";
import ColissimoIcon from "@redotech/redo-icons/carriers/colissimo.svg";
import CorreosIcon from "@redotech/redo-icons/carriers/correos.svg";
import DHLIcon from "@redotech/redo-icons/carriers/dhl.svg";
import DpdIcon from "@redotech/redo-icons/carriers/dpd.svg";
import EvriIcon from "@redotech/redo-icons/carriers/evri.svg";
import FedExIcon from "@redotech/redo-icons/carriers/fedex.svg";
import GlsIcon from "@redotech/redo-icons/carriers/gls.svg";
import InPostIcon from "@redotech/redo-icons/carriers/inpost.svg";
import MondialRelayIcon from "@redotech/redo-icons/carriers/mondial-relay.svg";
import NoCarrierIcon from "@redotech/redo-icons/carriers/no-carrier.svg";
import NzPostIcon from "@redotech/redo-icons/carriers/nz-post.svg";
import PosteItalianeIcon from "@redotech/redo-icons/carriers/poste-italiane.svg";
import PostNLIcon from "@redotech/redo-icons/carriers/postnl.svg";
import RoyalMailIcon from "@redotech/redo-icons/carriers/royalmail.svg";
import UPSIcon from "@redotech/redo-icons/carriers/ups.svg";
import USPSIcon from "@redotech/redo-icons/carriers/usps.svg";

/** Ordered: earlier tokens win, so "mondial relay by inpost" stays Mondial Relay. */
const carrierIconsByToken: readonly [string, typeof NoCarrierIcon][] = [
  ["ups", UPSIcon],
  ["fedex", FedExIcon],
  ["usps", USPSIcon],
  ["dhl", DHLIcon],
  ["amazon", AmazonIcon],
  ["australia", AustraliaPostIcon],
  ["austrian", AustrianPostIcon],
  ["canada", CanadaPostIcon],
  ["royal", RoyalMailIcon],
  ["bpost", BpostIcon],
  ["chronopost", ChronopostIcon],
  ["colissimo", ColissimoIcon],
  ["correos", CorreosIcon],
  ["dpd", DpdIcon],
  ["evri", EvriIcon],
  ["gls", GlsIcon],
  ["mondial", MondialRelayIcon],
  ["inpost", InPostIcon],
  ["nz post", NzPostIcon],
  ["poste italiane", PosteItalianeIcon],
  ["postnl", PostNLIcon],
];

/** Whether a carrier has its own badge, rather than falling back to the placeholder. */
export function hasCarrierIcon(carrier: string | null | undefined): boolean {
  const c = carrier?.toLowerCase();
  return !!c && carrierIconsByToken.some(([token]) => c.includes(token));
}

export function getCarrierIcon(carrier: string | null | undefined) {
  if (!carrier) {
    return NoCarrierIcon;
  }
  const c = carrier.toLowerCase();
  return (
    carrierIconsByToken.find(([token]) => c.includes(token))?.[1] ??
    NoCarrierIcon
  );
}
